"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const AkSpinner = require("@atlaskit/spinner").default;
const SpinnerSpan = styled_components_1.default.span `
  position: absolute;
  top: 50%;
  left: 50%;
`;
const InnerSpinnerSpan = styled_components_1.default.span `
  position: relative;
  top: -10px;
  left: -50%;
`;
class Spinner extends React.Component {
    render() {
        const { size } = this.props;
        return (React.createElement(SpinnerSpan, null,
            React.createElement(InnerSpinnerSpan, null,
                React.createElement(AkSpinner, { size: size ? size : "small", isCompleting: false }))));
    }
}
exports.Spinner = Spinner;
